import React, { useEffect, useState } from 'react';
import { filesize } from 'filesize';
import Spinner from './Spinner';
import { useServices } from 'services';

const Statistic = ({ number, name }: { number: number|undefined, name: string }): React.ReactElement => (
    
    <div
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '6rem',
            flexShrink: '0',
        }}
    >
        {number === undefined
            ? (
                <Spinner />
            )
            : (
                <span
                    style={{
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        textAlign: 'center',
                    }}
                >
                    {number}
                </span>
            )
        }
        <span
            style={{
                fontSize: '1rem',
                color: '#364153',
                fontWeight: 'bold',
                textAlign: 'center',
                textTransform: 'capitalize',
            }}
        >
            {name}
        </span>
    </div>
);

const Statistics = ({ project, projectSearchKey }: { project: string, projectSearchKey: string }): React.ReactElement => {

    const { envService } = useServices();

    const [datasetCount, setDatasetCount] = useState<number|undefined>();
    const [downloadCount, setDownloadCount] = useState<number|undefined>();
    const [sizeValue, setSizeValue] = useState<number|undefined>();
    const [sizeUnits, setSizeUnits] = useState<string>('bytes');

    useEffect(() => {
        fetch(
            encodeURI(`${envService.getValue('DATA_REPO_URL')}/api/records?q=msdlive_project:${projectSearchKey}`),
            {
                headers: {
                    "Accept": "application/vnd.inveniordm.v1+json",
                }
            }
        ).then(r => r.json()).then(r => {
            if (r?.hits?.hits?.length >= 0) {
                setDatasetCount(r.hits.hits.length);
            }
        });
        fetch(`${envService.getValue('DATA_REPO_URL')}/api/metrics/uploads`).then(r => r.json()).then(r => {
            const bytesTotal = r.totalbytes.reduce((b:number, d:{[key: string]: number}) => b + (d?.[project] ?? 0), 0);
            const formattedBytesTotal = filesize(bytesTotal, {
                fullform: true,
                precision: 4,
                standard: 'si',
                output: 'array',
                roundingMethod: 'floor',
            });
            setSizeValue(formattedBytesTotal[0]);
            setSizeUnits(formattedBytesTotal[1]);
        });
        fetch(`${envService.getValue('DATA_REPO_URL')}/api/metrics/downloads`).then(r => r.json()).then(r => {
            const downloads = r.uniqueDatasets.reduce((b:number, d:{[key: string]: number}) => b + (d?.[project] ?? 0), 0);
            setDownloadCount(downloads);
        });
    }, [project, projectSearchKey, envService])

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                gap: '1rem',
            }}
        >
            <Statistic number={datasetCount} name='Datasets' />
            <Statistic number={downloadCount} name='Downloads' />
            <Statistic number={sizeValue} name={sizeUnits} />
        </div>
    );

}

export default Statistics;
